// extracted by mini-css-extract-plugin
export default {"background":"NewPage_background__OMwXm","title":"NewPage_title__dJxMi","title_second":"NewPage_title_second__9iyz7"};